import React from 'react';

import {Checkmark} from '@kit';

import css from './sheet.module.css';

type Props = {
	checked: boolean;
	onChange(checked: boolean): void;
	children: React.ReactNode;
};

export const InlineCheck: React.FC<Props> = ({checked, onChange, children}) => (
	<button
		type="button"
		role="checkbox"
		aria-checked={checked}
		className={css.inlineCheck}
		onClick={() => onChange(!checked)}
	>
		<Checkmark checked={checked} />
		{children}
	</button>
);
